import React from "react"
import SVG from "react-inlinesvg"
import * as styles from "./SupplierSearchFilterListOption.module.scss"

const SupplierSearchFilterListOption = ({ option, handleChange, isMutli, name, checked }) => {
  const optionId = `${name}-${option.value}`

  const icon = checked ? option.iconActive : option.icon
  return (
    <li  className={`${styles.SupplierSearchFilterListOption} ${checked ? styles.checked : ""}`}>
      <label htmlFor={optionId}>
        {icon ? (
          <SVG
            src={icon.url}
            width={20}
            height="100%"
            preProcessor={(code) => code.replace(/style=".*?"/g, 'style=""')}
          />
        ) : null}
        <span>{option.label}</span>
        <input
          type={isMutli ? "checkbox" : "radio"}
          name={isMutli ? option.value : name}
          id={optionId}
          value={option.value}
          onChange={handleChange}
          checked={checked}
          data-label={option.label}
          data-icon={option.iconActive?.url}
        />
      </label>
    </li>
  )
}

export default SupplierSearchFilterListOption
